
import { motion } from "framer-motion";

interface FeatureCardsProps {
  images: {
    cooking1: string;
    cooking2: string;
    cooking3: string;
  };
}

export const FeatureCards = ({ images }: FeatureCardsProps) => {
  return (
    <motion.div 
      className="grid md:grid-cols-3 gap-8 mt-20"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
    >
      <div className="bg-background/80 backdrop-blur-sm p-6 rounded-lg overflow-hidden">
        <img 
          src={images.cooking1}
          alt="Learning science through cooking"
          className="w-full h-48 object-cover rounded-lg mb-4"
        />
        <div className="text-3xl mb-4">🔬</div>
        <h3 className="text-xl font-semibold mb-2">Learn Science</h3>
        <p className="text-muted-foreground">
          Discover the fascinating science behind cooking reactions and ingredient transformations.
        </p>
      </div>
      <div className="bg-background/80 backdrop-blur-sm p-6 rounded-lg overflow-hidden">
        <img 
          src={images.cooking2}
          alt="Kids tracking cooking progress"
          className="w-full h-48 object-cover rounded-lg mb-4"
        />
        <div className="text-3xl mb-4">📝</div>
        <h3 className="text-xl font-semibold mb-2">Track Progress</h3>
        <p className="text-muted-foreground">
          Keep a digital cooking journal to document your culinary adventures and achievements.
        </p>
      </div>
      <div className="bg-background/80 backdrop-blur-sm p-6 rounded-lg overflow-hidden">
        <img 
          src={images.cooking3}
          alt="Kids making healthy food choices"
          className="w-full h-48 object-cover rounded-lg mb-4"
        />
        <div className="text-3xl mb-4">🥗</div>
        <h3 className="text-xl font-semibold mb-2">Healthy Choices</h3>
        <p className="text-muted-foreground">
          Learn about nutritious ingredient alternatives and why they're better for you.
        </p>
      </div>
    </motion.div>
  );
};
